import { NavigationAnchor } from "@/components/layout/types";
import {
  Module,
  PATH_DEFAULT_STORE_PROJECT_ASSIGNEES,
  PATH_STORE_PROJECT_ASSIGNEES,
  PATH_STRUCTURE_ASSIGNMENTS,
} from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import { ASSIGNMENT_TYPES } from "@/schemas/structure-assignment";
import { UserStar, Workflow } from "lucide-react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";

export const useStructureAssignmentsMenuItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const structurePermissions = useModulePermissions(
    Module.StructureAssignments,
  );

  return [
    {
      icon: Workflow,
      url: generatePath(PATH_STRUCTURE_ASSIGNMENTS, {
        assignmentType: ASSIGNMENT_TYPES.RR_2_RD,
      }),
      permission: structurePermissions.structure_assignments_rr_to_rd_read,
      title: t("structureAssignments.navigation.rr_2_rd"),
    },
    {
      icon: Workflow,
      url: generatePath(PATH_STRUCTURE_ASSIGNMENTS, {
        assignmentType: ASSIGNMENT_TYPES.RR_2_FAM,
      }),
      permission: structurePermissions.structure_assignments_rr_to_fam_read,
      title: t("structureAssignments.navigation.rr_2_fam"),
    },
    {
      icon: Workflow,
      url: generatePath(PATH_STRUCTURE_ASSIGNMENTS, {
        assignmentType: ASSIGNMENT_TYPES.KAM_2_CSD,
      }),
      permission: structurePermissions.structure_assignments_kam_to_csd_read,
      title: t("structureAssignments.navigation.kam_2_csd"),
    },
    {
      icon: UserStar,
      url: PATH_DEFAULT_STORE_PROJECT_ASSIGNEES,
      permission: permissions[Module.DefaultStoreProjectAssignees].can_read,
      title: t("navigation.defaultStoreProjectAssignee"),
    },
    {
      icon: UserStar,
      url: PATH_STORE_PROJECT_ASSIGNEES,
      permission: permissions[Module.StoreProjectAssignees].can_read,
      title: t("navigation.storeProjectAssignee"),
    },
  ];
};
